<template>
<div class="look-account">
   <el-card class="box-card">
    <div slot="header" class="clearfix" style="text-align:left;">
      <a style="text-decoration:none;color:#337ab7;cursor:pointer;" @click="returnBack">返回</a>
      <span style="line-height: 36px;margin-left:60px;">用户名：</span>
      <span>{{accTel}}</span>
      <span>{{accName}}</span>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <!-- <el-table-column
        header-align="center"
        type="selection"
        fixed="left"
        width="40">
      </el-table-column> -->
      <el-table-column
        prop="code"
        header-align="center"
        width="95"
        label="设备编号">
      </el-table-column>
      <el-table-column
        prop="alias"
        header-align="center"
        min-width="115"
        label="设备别名">
      </el-table-column>
      <el-table-column
        prop="version"
        header-align="center"
        min-width="120"
        label="设备版本">
      </el-table-column>
      <el-table-column
        prop="address"
        header-align="center"
        min-width="225"
        label="设备地址">
      </el-table-column>
       <el-table-column
        prop="status"
        header-align="center"
        min-width="105"
        label="是否状态">
        <template scope="scope">
          <el-tag :type="scope.row.status === '离线' ? 'danger' : 'success'"
            close-transition>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
       <el-table-column
        prop="paperNum"
        header-align="center"
        min-width="185"
        label="货量电量">
        <template scope="scope">
           <span style="color:green;">货物量:{{scope.row.paperNum}} </span>
           <!-- <span style="color:green;">电量:{{scope.row.batery}}</span> -->
          </template>
      </el-table-column>
      <!-- <el-table-column
        prop="addCount"
        header-align="center"
        min-width="105"
        label="补货次数">
      </el-table-column> -->
      <el-table-column
        prop="location"
        header-align="center"
        min-width="105"
        label="所在场景">
      </el-table-column>
      <el-table-column
        prop=""
        header-align="center"
        min-width="185"
        label="广告资源">
          <template scope="scope">
            <el-button 
              @click="seeNext('ad', scope.row.code)" 
              type="text" size="small">广告</el-button>
            <el-button 
              @click="seeNext('weixin', scope.row.code)" 
              type="text" size="small">公众号</el-button>
              <el-button 
              @click="seeNext('deviceInfo', scope.row.code)" 
              type="text" size="small">设备信息</el-button>
          </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  <pu-see-pop-right 
    v-if="seeShow"
    :see-pop-right-ok="seePopRightOk" 
    :device-code="deviceCode"
    :see-type = 'seeType'
    @closeSeeRightPop="closeSeeRightPop">
  </pu-see-pop-right>
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import puSeePopRight from '@/page/deviceMgr/seePopRight'
    // import {isNull} from '../../js/tool'

    export default {
      data () {
        return {
          deviceData: [],
          deviceCode: '',
          searchSelect: '1',
          searchKey: '',
          appId: this.$route.query.id,
          accTel: this.$route.query.tel,
          accName: this.$route.query.name,
          accType: Number(this.$route.query.type),
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          seeShow: false,
          seePopRightOk: false,
          multipleSelection: '',
          seeType: '',
          table_loading: false
        }
      },
      created: function () {
        this.pageNo = 1
        if (this.accType === 2) {
          this.querySbzDeviceList(this.pageNo, this.pageSize)
        } else {
          this.queryDeviceList(this.pageNo, this.pageSize, this.appId, this.accType)
        }
      },
      methods: {
        querySbzDeviceList (tPageNo, tPageSize) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            userId: _this.appId
          }
          this.table_loading = true
          $axios.get('/para/queryEntranceQrCodeDeviceList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    code: itemData.deviceCode,
                    alias: itemData.alias,
                    version: itemData.deviceModel,
                    address: itemData.address,
                    status: itemData.isOnline === 1 ? '在线' : '离线',
                    paperNum: itemData.paperNum,
                    batery: itemData.batery,
                    addCount: itemData.supplementNum,
                    locationRoom: itemData.locationRoom
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },

        queryDeviceList (tPageNo, tPageSize, tAppId, tAccType) {
          console.log(22222)
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            appid: tAppId
          }
          this.table_loading = true
          $axios.get('/para/queryEntranceQrCodeDeviceList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    code: itemData.deviceCode,
                    alias: itemData.alias,
                    version: itemData.deviceModel,
                    address: itemData.address,
                    status: itemData.isOnline === 1 ? '在线' : '离线',
                    paperNum: itemData.paperNum,
                    batery: itemData.batery,
                    addCount: itemData.supplementNum,
                    locationRoom: itemData.locationRoom
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        seeNext (mSeeType, mDeviceCoe) {
          this.deviceCode = mDeviceCoe
          this.seeType = mSeeType
          this.seePopRightOk = true
          this.seeShow = true
        },
        closeSeeRightPop () {
          this.seePopRightOk = false
          if (this.accType === 2) {
            this.querySbzDeviceList(this.pageNo, this.pageSize)
          } else {
            this.queryDeviceList(this.pageNo, this.pageSize, this.appId, this.accType)
          }
          // if (isNull(this.searchValue)) {
          //   this.queryDeviceList(this.pageNo, this.pageSize, '')
          // } else {
          //   this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          // }
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (this.accType === 2) {
            this.querySbzDeviceList(this.pageNo, this.pageSize)
          } else {
            this.queryDeviceList(this.pageNo, this.pageSize, this.appId, this.accType)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (this.accType === 2) {
            this.querySbzDeviceList(this.pageNo, this.pageSize)
          } else {
            this.queryDeviceList(this.pageNo, this.pageSize, this.appId, this.accType)
          }
        },
        handleSelectionChange (selection) {
          this.multipleSelection = ''
          for (var i = 0; i < selection.length; i++) {
            this.multipleSelection += (selection[i].code + '|')
          }
        },
        searchInput () {
        },
        returnBack () {
          this.$router.back(-1)
        },
        removeDevice () {
          var that = this
          if (that.multipleSelection.length === 0) {
            that.$alert('请选择要回收的资源', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            return false
          }
          that.$confirm('您已选择设备：' + that.multipleSelection, '回收后可以在未分配列表重新分配', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var params = {
              deviceId: that.multipleSelection
            }
            $axios.get('/device/recoveryDevice', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.pageNo = 1
                if (that.accType === '2') {
                  that.querySbzDeviceList(that.pageNo, that.pageSize)
                } else {
                  that.queryDeviceList(that.pageNo, that.pageSize, that.appId, that.accType)
                }
                that.$message({
                  type: 'success',
                  message: '回收设备成功!'
                })
              } else {
                that.$message({
                  type: 'error',
                  message: '回收设备失败'
                })
              }
            }, function () {
              that.$message({
                type: 'error',
                message: '回收设备失败'
              })
            })
          }).catch(() => {
          })
        }
      },
      components: {
        'pu-see-pop-right': puSeePopRight
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .look-account {
      .el-select .el-input {
        width: 110px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/page/adMgr/entryQrcodeDeviceList.vue